{
  "consent": {
    "title": "Подключение приложения",
    "intro": "{{name}} просит доступ к CloudServer от вашего имени. Выберите, что приложению можно, — больше ваших прав оно не получит никогда.",
    "secondFactor": "Разрешение подтверждается вторым фактором",
    "app": "Приложение",
    "returnsTo": "Ответ уйдёт на",
    "resource": "Доступ к",
    "onlyIfYou": "Разрешайте, только если вы сами только что начали подключение в этом приложении. Если нет — нажмите «Отклонить».",
    "warnings": {
      "localRedirect": "Ответ уйдёт программе на этом компьютере ({{host}}). Такой адрес может занять любая программа: разрешайте, только если вы сами подключаете приложение на этом компьютере.",
      "selfNamed": "Название приложение указало само, мы его не проверяли. Проверьте адрес, на который уйдёт ответ."
    },
    "policy": "Что приложению можно",
    "policyLead": "Как у API-ключа: шаблон, политика организации или свои правила. Удаление и пересоздание лучше не разрешать без нужды.",
    "allowSecretLead": "Приложение сможет добавлять SSH-ключи и включать режим восстановления. Пароли root и консоль через MCP не выдаются никогда.",
    "projects": "В каких проектах",
    "allProjectsLead": "Все проекты, которые вам доступны, и будущие тоже.",
    "someProjectsLead": "Только отмеченные проекты.",
    "gets": "Что получит приложение",
    "getsPolicy": "Права «{{policy}}» в проектах: {{projects}}.",
    "getsNeverMore": "Никогда больше ваших собственных прав: если ваши права сузят, сузятся и права приложения.",
    "getsSecret": "Секретные действия разрешены (SSH-ключи, режим восстановления), но не пароли и не консоль.",
    "getsNoSecret": "Без секретных действий: SSH-ключи, пароли и консоль недоступны.",
    "getsTokens": "Токены доступа живут {{minutes}} минут и обновляются сами; доступ сохранится до {{until}}, если вы не отключите приложение раньше.",
    "getsRevoke": "Отключить приложение можно в любой момент: «API и интеграции» → «Подключённые приложения».",
    "allow": "Разрешить",
    "deny": "Отклонить",
    "leaving": "Возвращаем вас на {{host}}…",
    "toApps": "К подключённым приложениям",
    "errors": {
      "invalid_client": "Приложение неизвестно или его описание не прошло проверку. Начните подключение в приложении заново.",
      "invalid_redirect_uri": "Приложение просит вернуть ответ на адрес, который оно не регистрировало. Мы не отправим туда ответ.",
      "invalid_request": "Запрос на подключение неполный или неверный. Начните подключение в приложении заново."
    }
  },
  "kind": {
    "document": "Проверено по {{host}}",
    "dynamic": "Название указано самим приложением"
  },
  "apps": {
    "empty": "Нет подключённых приложений",
    "emptyLead": "Когда вы подключите CloudServer в claude.ai, приложении Claude или ChatGPT, приложение появится здесь: что ему можно, когда оно работало, кнопка «Отключить».",
    "name": "Приложение",
    "returnsTo": "отвечает на {{host}}",
    "user": "Чьё",
    "open": "Открыть",
    "activityEmptyLead": "Здесь появятся вызовы приложения через MCP и изменения самого подключения."
  },
  "app": {
    "intro": "Подключено через вход в CloudServer и действует от имени {{user}}.",
    "client": "Клиент OAuth",
    "redirect": "Адрес ответа",
    "connected": "Подключено",
    "until": "Доступ до",
    "revokedAt": "Отключено",
    "whatLead": "Пересечение выбранной политики и прав человека, от чьего имени работает приложение."
  },
  "revoke": {
    "title": "Отключить «{{name}}»?",
    "stops": "Приложение сразу потеряет доступ: его токены перестанут работать.",
    "again": "Чтобы снова пользоваться им, приложению придётся заново попросить разрешение.",
    "action": "Отключить",
    "done": "«{{name}}» отключено"
  },
  "activity": {
    "oauth_app_created": "Приложение подключено",
    "oauth_app_revoked": "Приложение отключено",
    "oauth_app_refused": "Вызов приложения отклонён",
    "oauth_app_denied": "В подключении отказано",
    "oauth_app_refresh_reused": "Повторное использование токена — приложение отключено"
  }
}
